import { ServiceOrder, ServiceOrderType } from '@mews-commander/data-access';

type ServiceOrderProductServiceOrder = ServiceOrder & { data: { discriminator: ServiceOrderType.ProductServiceOrder } };

export const isProductServiceOrder = (serviceOrder: ServiceOrder): serviceOrder is ServiceOrderProductServiceOrder =>
    serviceOrder.data.discriminator === ServiceOrderType.ProductServiceOrder;

type ServiceOrderReservation = ServiceOrder & { data: { discriminator: ServiceOrderType.Reservation } };

export const isReservation = (serviceOrder: ServiceOrder): serviceOrder is ServiceOrderReservation =>
    serviceOrder.data.discriminator === ServiceOrderType.Reservation;
